import React from 'react'
import { Modal } from 'react-bootstrap'
import SignUpForm from './SignUpForm'

const SignUp = ({
  show,
  setVisibility,
  setCustomerEmail,
  signUpCallbackUrl,
  isSettingsPage,
  verifyLink,
  iosAppClientId,
  iosAppVersion,
  iosAppApiVersion,
  setSubmitData = () => {},
  iosAppScope
}) => {
  const queryParams = new URLSearchParams(window.location.search)
  const callBackUrl = queryParams.get('redirect_to')

  return (
    <Modal
      show={show}
      onHide={() => setVisibility(false)}
      className='signupModal'
    >
      <Modal.Header
        closeButton
        className={isSettingsPage ? 'signupHeaderMembership' : 'signupHeader'}
      ></Modal.Header>
      <Modal.Body style={{ textAlign: 'left' }}>
        <SignUpForm
          isSettingsPage={isSettingsPage}
          setVisibility={setVisibility}
          setCustomerEmail={setCustomerEmail}
          signUpCallbackUrl={callBackUrl ?? signUpCallbackUrl}
          verifyLink={verifyLink}
          iosAppClientId={iosAppClientId}
          iosAppVersion={iosAppVersion}
          iosAppApiVersion={iosAppApiVersion}
          iosAppScope={iosAppScope}
          setSubmitData={setSubmitData}
        />
      </Modal.Body>

      <Modal.Footer style={{ borderWidth: 0 }}></Modal.Footer>
    </Modal>
  )
}

SignUp.propTypes = {}

export default SignUp
